import React, { useState, useEffect, useContext, CSSProperties } from 'react';

import { ExamContext } from '../context/ExamContext'
import { BasicContext } from '../context/BasicContext'
import WebServiceContext from '../WebService/ServiceContext'
import { Yes, No, Not } from '../course/SVG';

type thisProps = {
    nowNum: number
    //exams: ExamUnit[]
    doAnswer: (ans: boolean) => void
    answerResult: boolean
    //endTemplate: JSX.Element;
}


type IndicatorsProps = {
    list: []
    active: number
}

const Indicators = (props: IndicatorsProps) => {
    return (
        <div className='indicators'>
            {
                props.list.map(
                    (item: object, index: number) =>
                        <div key={"indicators_" + index} className={props.active == index ? "active" : ""}>
                        </div>
                )
            }
        </div>
    )
}

//const ansNowList:ExamAnswer[] = []

export default (props: thisProps) => {

    const bc = useContext(BasicContext)
    const ec = useContext(ExamContext)
    const ws = useContext(WebServiceContext)

    const [examList, setExamList] = useState<Array<ExamUnit> | undefined>()
    const [num, setNum] = useState<number>(props.nowNum)
    const [ansRes, setAnsRes] = useState<boolean>(true)
    const [yesOrNo, setYesOrNo] = useState<boolean>(true)
    const [ansState, setAnsState] = useState<string>("")
    const [ansSelect, setAnsSelect] = useState<string>("")
    const [ansKind, setAnsKind] = useState<boolean>(true);//控制答題方式

    //取得當下答題的答案，送出答題後將會記錄到ansNowList
    //const [ansNow, setAnsNow] = useState<ExamAnswer|null>();//控制答題方式
    const [ansNow, setAnsNow] = useState<ExamAnswer | null>();//控制答題方式

    //紀錄有改變就寫入資料
    useEffect(() => {
        const tdo: TempDataObject = {
            Action: "UPDATE",
            ActID: bc.ActID,
            ExamID: ec.examInfo.ExamID,
            TempData: JSON.stringify({
                examData: ec.examData,
                record: ec.record
            })
        }
        ws.ExamService.tempDataAction(tdo).then(res => {
            //console.log(res)
        })
        console.log(ec.record)
    }, [ec.record])

    useEffect(() => {
        if (ec.examInfo.AnsKind == "2") {
            setAnsKind(false)
        }
    }, [ec.examInfo])

    useEffect(() => {
        if (ec.examData.length > 0) {
            setExamList(ec.examData)
        }
    }, [ec.examData])

    useEffect(() => {
        setNum(props.nowNum)
    }, [props.nowNum])

    const answerHandler = (Ans: boolean) => {
        if (ansState != "") {
            props.doAnswer(Ans);
        }
    }

    const resultHandler = () => {
        setAnsRes(true)
        if (ansState == "1") {
            setAnsState("")
        }
    }

    if (examList != undefined) {
        return (
            <div className='quest-panel'>
                {
                    (ansRes || ansState != "1") &&
                    <div className='quest-title'>
                        <span>
                            {num + 1}.
                        </span>
                        <span>
                            {examList[num].question}
                        </span>
                    </div>
                }
                <div>
                    {
                        ansRes == true ?
                            <div className='quest-item-box'>
                                {
                                    examList[num].answersList.map((ans: ExamAnswer, aSN: number) =>
                                        <div className='quest-item' key={"answersList_" + aSN}>
                                            <input
                                                type="radio"
                                                name="ans"
                                                checked={aSN.toString() == ansSelect ? true : false}
                                                value={ans.Ans == true ? 1 : 0}
                                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                    setAnsSelect(aSN.toString())
                                                    setAnsState(event.target.value.toString())
                                                }}
                                            />
                                            <span className='quest-text'>
                                                <span >
                                                    {ans.ItemID}.
                                                </span>
                                                <span >
                                                    {ans.ItemTitle}
                                                </span>
                                            </span>
                                        </div>
                                    )
                                }
                                <button
                                    className="hibBtn main full large answer"
                                    onClick={() => {

                                        //--答題類型1 作答到對
                                        if (ec.examInfo.AnsKind == "1") {
                                            setAnsRes(false)
                                            if (ansState == "1") {
                                                answerHandler(true)
                                            }
                                            //--答題類型2 直接下一提
                                        } else if (ec.examInfo.AnsKind == "2") {
                                            if (ansSelect) {
                                                //記錄答題 start
                                                //找出正確的答案 如果沒有的話回傳null
                                                const rightAns = examList[num].answersList.find((item) => {
                                                    if (item.Ans) {
                                                        return item.ItemID
                                                    } else {
                                                        return null
                                                    }
                                                })

                                                //console.log(examList[num])
                                                ec.setRecord([...ec.record,
                                                {
                                                    title: examList[num].question,
                                                    rightAns: rightAns,
                                                    userAns: examList[num].answersList[parseInt(ansSelect)]
                                                } as ExamRightAnswer
                                                ])
                                                //記錄答題 end
                                            }
                                            const res = (ansState == "1" ? true : false)
                                            answerHandler(res)
                                            setAnsState("")
                                        }

                                        setAnsSelect("")//清空選擇

                                        if (ansState == "") {
                                            setAnsRes(false)
                                        }
                                    }}
                                >確認答案，下一題</button>
                            </div>
                            :
                            <>
                                {
                                    ansState == "1" ?
                                        <Yes /> :
                                        ansState == "0" ?
                                            <No /> :
                                            <Not />
                                }

                                <button className='hibBtn main full large answer' onClick={resultHandler} >
                                    {
                                        ansState == "1" ?
                                            "答對了！繼續下一題" :
                                            ansState == "0" ?
                                                "答錯了！請再想想，重新答題" :
                                                "您尚未選擇答案"
                                    }
                                </button>
                            </>
                    }
                </div>

                <Indicators
                    list={examList as []}
                    active={num}
                />

            </div>
        )

    } else {
        return (
            <div>設定中</div>
        )
    }
}